// Client mirror of functions-common/src/charts/datasets/budget.ts. Keep in sync.

import type { DatasetDefinition } from '../types.js'

export const budgetDataset: DatasetDefinition = {
  key: 'budget',
  labelKey: 'NLSChartDatasetBudget',
  fields: [
    { name: 'category', labelKey: 'NLSChartFieldCategory', kind: 'dimension', type: 'string' },
    { name: 'vendor', labelKey: 'NLSChartFieldVendor', kind: 'dimension', type: 'string' },
    { name: 'person', labelKey: 'NLSChartFieldPerson', kind: 'dimension', type: 'string' },
    { name: 'goal', labelKey: 'NLSChartFieldGoal', kind: 'dimension', type: 'string' },
    { name: 'incomeExpense', labelKey: 'NLSChartFieldIncomeExpense', kind: 'dimension', type: 'string' },
    { name: 'amount', labelKey: 'NLSChartFieldAmount', kind: 'measure', type: 'number' },
    { name: 'entries', labelKey: 'NLSChartFieldEntries', kind: 'measure', type: 'number' },
    { name: 'budgetLimit', labelKey: 'NLSChartFieldBudgetLimit', kind: 'measure', type: 'number' },
    { name: 'entryDate', labelKey: 'NLSChartFieldEntryDate', kind: 'time', type: 'date' },
  ],
  defaultMeasure: { field: 'amount', agg: 'sum' },
  defaultTimeField: 'entryDate',
  allowedRoles: ['OWNER', 'ADMIN', 'EDITOR', 'HELPER', 'VIEWER'],
  available: true,
}
